/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import MovinIcon from '../assets/icons/movin.png'

function SortableItem({ id, label, onRemove }: any) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? '#001842ff' : '#002b80',
    padding: '10px 14px',
    borderRadius: 8,
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'grab',
    width: '100%',
    boxSizing: 'border-box',
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        <img src={MovinIcon} alt='Mover' width={24} />
        <span style={{ fontWeight: 600 }}>{label}</span>
      </div>
      <button
        onClick={() => onRemove(id)}
        style={{
          border: 'none',
          background: 'transparent',
          color: 'white',
          cursor: 'pointer',
          fontWeight: 'bold',
        }}
      >
        X
      </button>
    </div>
  )
}

interface FieldOption {
  key: string
  label: string
  visible?: boolean
  table?: string
  type?: string
}

interface CamposOrdenaveisProps {
  selectedFields: string[]
  setSelectedFields: (value: string[]) => void
  fields: FieldOption[]
}

export function CamposOrdenaveis({
  selectedFields,
  setSelectedFields,
  fields,
}: CamposOrdenaveisProps) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    }),
  )

  const onDragEnd = (event: any) => {
    const { active, over } = event
    if (!over || active.id === over.id) return

    const oldIndex = selectedFields.indexOf(active.id)
    const newIndex = selectedFields.indexOf(over.id)

    const reordered = arrayMove(selectedFields, oldIndex, newIndex)
    setSelectedFields(reordered)
  }

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={selectedFields} strategy={verticalListSortingStrategy}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            paddingRight: 4,
          }}
        >
          {selectedFields.map((key) => {
            const f = fields.find((x) => x.key === key)
            if (!f) return null

            return (
              <SortableItem
                key={key}
                id={key}
                label={f.label}
                onRemove={(id: string) => {
                  const newList = selectedFields.filter((k) => k !== id)
                  setSelectedFields(newList)
                }}
              />
            )
          })}
        </div>
      </SortableContext>
    </DndContext>
  )
}
